import { Url } from '../shared/Url';
import Post from '../shared/Post';

import { consultaUser } from './PefilFunction';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const ConsultaMaterias = (respuesta) => {
    consultaUser ((usuario) => {
        let Content = {
            id: usuario
        }

        Post(`${Url}consultMateriasIns`, Content, (resp) => {
            let data = JSON.parse(resp)
            let contenido = []
            if(data.status === "ok"){
                let cont = data.contenido;
                for (let i in cont){
                    let tipo = "";
                    console.log(cont[i]);
                    switch (parseInt(cont[i].tipo_curso)) {
                        case 1:
                            tipo = 'Presencial';
                            break;
                        case 2:
                            tipo = 'Prueba de Suficiencia' ;
                            break;
                        case 3:
                        tipo = 'Verano' ;
                            break;
                        default:
                            tipo = 'Presencial';
                            break;
                    }
                    
                    contenido.push({
                        id: cont[i].id,
                        materia: cont[i].materia_name,
                        seccion: cont[i].nombre,
                        tipo: tipo,
                        uc: cont[i].u_c,
                        status: cont[i].status,
                    })
                }
            }
            respuesta(contenido)
        });
    })
}

export const Delete = (id, cantidad, respuesta) => {
    if (cantidad < 2){
        toast.warning("Debes tener inscrita al menos una materia",{autoClose: 4000});
        respuesta([false, false])
        return null;
    } 
    consultaUser ((usuario) => {
        let Content = {
            id: id,
            usuario: usuario
        }
        Post(`${Url}delMateriasIns`, Content, () => {
            respuesta([false, true])
        });
    })
}


// WEBPACK FOOTER //
// ./src/funciones/RetiroFunction.jsx